export default function getImgSrc(img) {
	if (!img) return img;
	if (typeof img !== 'string') return img;
	if (img.startsWith('http') || img.startsWith('data:')) return img;
	return `${process.env.REACT_APP_API_URL}${img}`;
}
